var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-main"},[_c('nav-bar'),_c('router-view'),_c('custom-footer'),_c('modal-lead')],1)}
var staticRenderFns = []

export { render, staticRenderFns }